module.exports = __webpack_public_path__ + "fontawesome-webfont.woff?fee66e712a8a08eef5805a46892932ad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 722
// module chunks = 27